import React, { useEffect, useRef, useState } from "react";
import { Modal } from "antd";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../ToastComponent";
import { Api_Url } from "../../../config/config";
import { AllFormsUpperphoto } from "../../../Routes/ImagePath";

export const AddPreDisbursalCollectionVisitModel = ({
  loadPropertDataFunction,
  onClose,
}) => {
  const [loading, setLoading] = useState(false);
  const [allbranch, setAllBranch] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]); // For customer dropdown
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const fileInputRef = useRef(null);
  const selfieInputRef = useRef(null);
  const [showCustomerOptions, setShowCustomerOptions] = useState(false);

  const [LocalFormData, setLocalFormData] = useState({
    BranchId: "",
    Name: "",
    Mobile: "",
    VerificationStatus: "",
    ApplicationNo: "",
    VisitSelfie: [],
    VisitorSelfie: [],
    Latitude: "",
    Longitude: "",
    VisitRemark: "",
  });

  const datastatus = [
    { label: "Positive", value: 1 },
    { label: "Negative", value: 2 },
  ];

  useEffect(() => {
    fetchBranchData();
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setLocalFormData((prevData) => ({
          ...prevData,
          Latitude: latitude,
          Longitude: longitude,
        }));
      });
    }
  }, []);

  const fetchBranchData = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setAllBranch(response.data.data);
    } catch (error) {
      console.error("Error fetching branch data", error);
    }
  };

  const fetchCustomerData = async (branchId, query) => {
    if (!branchId || query.length < 2) return;

    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Customer/bybranchidandname/${branchId}/${query}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setCustomerOptions(response.data.data || []);
    } catch (error) {
      console.error("Error fetching customer data", error);
    }
  };

  const handleCustomerChange = (query) => {
    if (debounceTimeout) clearTimeout(debounceTimeout);

    setDebounceTimeout(
      setTimeout(() => {
        fetchCustomerData(LocalFormData.BranchId, query);
      }, 300) // Adjust debounce delay as needed
    );
  };

  const handleCustomerSelect = (customerName) => {
    const selectedCustomer = customerOptions.find(
      (customer) => customer.name === customerName.name
    );
    if (selectedCustomer) {
      setLocalFormData({
        ...LocalFormData,
        Name: selectedCustomer.name,
        ApplicationNo: selectedCustomer.applicationNo, // Autofill application number
      });
      setShowCustomerOptions(false);
    }
  };

  const validateForm = () => {
    if (!LocalFormData.BranchId) {
      ErrorToast("Please select a branch.");
      return false;
    }
    if (!LocalFormData.Name) {
      ErrorToast("Please enter the customer's name.");
      return false;
    }
    if (!LocalFormData.VisitSelfie) {
      ErrorToast("Please upload a Visit Picture.");
      return false;
    }
    if (!LocalFormData.VisitorSelfie) {
      ErrorToast("Please upload a Selfie.");
      return false;
    }
    if (!LocalFormData.VerificationStatus) {
      ErrorToast("Please enter verification status .");
      return false;
    }
    if (!LocalFormData.VisitRemark) {
      ErrorToast("Please enter visit remark.");
      return false;
    }
    if (!LocalFormData.ApplicationNo) {
      ErrorToast("Please enter Application No.");
      return false;
    }
    return true;
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setLocalFormData((prevData) => ({
      ...prevData,
      VisitSelfie: files,
    }));
  };

  const handleSelfieChange = (e) => {
    const files = Array.from(e.target.files);
    setLocalFormData((prevData) => ({
      ...prevData,
      VisitorSelfie: files,
    }));
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;

    if (/^[0-9]{0,10}$/.test(value)) {
      setLocalFormData({ ...LocalFormData, Mobile: value });
    }
  };

  const HandleSubmit = async () => {
    if (!validateForm()) return;
    setLoading(true);

    const formData = new FormData();

    // Append VisitSelfie files
    if (LocalFormData.VisitSelfie.length > 0) {
      LocalFormData.VisitSelfie.forEach((file) => {
        formData.append("VisitSelfie", file); // Append each file individually
      });
    }

    // Append VisitorSelfie files
    if (LocalFormData.VisitorSelfie.length > 0) {
      LocalFormData.VisitorSelfie.forEach((file) => {
        formData.append("VisitorSelfie", file); // Append each file individually
      });
    }

    // Append the rest of the form data
    Object.keys(LocalFormData).forEach((key) => {
      if (key !== "VisitSelfie" && key !== "VisitorSelfie") {
        formData.append(key, LocalFormData[key]);
      }
    });

    try {
      const response = await axios.post(
        `${Api_Url}api/v1/PreDisbursalVisit`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      loadPropertDataFunction();
      resetForm();
      SuccessToast("Pre-Disbursal Submitted Successfully");
      onClose();
    } catch (error) {
      ErrorToast("An Error Occurred while Submitting.");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setLocalFormData({
      BranchId: "",
      Name: "",
      Mobile: "",
      VerificationStatus: "",
      ApplicationNo: "",
      VisitSelfie: [],
      VisitorSelfie: [],
      Latitude: "",
      Longitude: "",
      VisitRemark: "",
    });
    setCustomerOptions([]);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  return (
    <Modal
      title={<h4>Add Pre-Disbursal Visit</h4>}
      open={true}
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <div
          className="d-flex justify-content-between align-items-center"
          key="footer"
        >
          <button className="btn btn-danger submit-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary submit-btn"
            onClick={HandleSubmit}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>,
      ]}
      width={600}
      maskClosable={false}
      closeIcon={<span style={{ color: "red" }}>X</span>}
    >
      <div className="modal-body mt-5">
        <div className="profile-image text-center mt-4 mb-4">
          <img
            src={AllFormsUpperphoto}
            alt="Profile"
            className="img-fluid rounded-circle"
            style={{ width: "100px", height: "100px" }}
          />
        </div>
        <form>
          <div className="row">
            <div className="col-md-6">
              <label className="col-form-label">
                Branch <span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                value={LocalFormData.BranchId}
                onChange={(e) =>
                  setLocalFormData({
                    ...LocalFormData,
                    BranchId: e.target.value,
                  })
                }
              >
                <option value="">Select Branch</option>
                {allbranch.map((branch) => (
                  <option key={branch.id} value={branch.id}>
                    {branch.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-6 col-sm-12 position-relative">
              <label className="col-form-label">
                Customer Name <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                type="text"
                value={LocalFormData.Name}
                onChange={(e) => {
                  setLocalFormData({
                    ...LocalFormData,
                    Name: e.target.value,
                  });
                  handleCustomerChange(e.target.value);
                }}
                onFocus={() => setShowCustomerOptions(true)} // Show options when input is focused
                onBlur={() =>
                  setTimeout(() => setShowCustomerOptions(false), 200)
                } // Hide dropdown on blur
              />
              {showCustomerOptions && customerOptions.length > 0 && (
                <div
                  className="dropdown-container position-absolute w-100 mt-1"
                  style={{ maxHeight: "200px", overflowY: "auto" }}
                >
                  <ul className="list-group">
                    {customerOptions.map((customer) => (
                      <li
                        key={customer.id}
                        className="list-group-item list-group-item-action"
                        onClick={() =>
                          handleCustomerSelect(customer, customer.applicationNo)
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {customer.name} ({customer.applicationNo})
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">Mobile</label>
                <input
                  className="form-control"
                  type="number"
                  value={LocalFormData.Mobile}
                  onChange={handleMobileChange}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Verification Status <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={LocalFormData.VerificationStatus}
                  onChange={(e) =>
                    setLocalFormData({
                      ...LocalFormData,
                      VerificationStatus: e.target.value,
                    })
                  }
                >
                  <option value="">Select Status</option>
                  {datastatus.map((verificationstatus) => (
                    <option
                      key={verificationstatus.id}
                      value={verificationstatus.id}
                    >
                      {verificationstatus.label}
                    </option>
                  ))}
                  {/* Add more branches as needed */}
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Application No.<span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  value={LocalFormData.ApplicationNo}
                  onChange={(e) =>
                    setLocalFormData({
                      ...LocalFormData,
                      ApplicationNo: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="col-md-6">
              <label className="col-form-label">
                Upload Selfie <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                type="file"
                accept="image/*"
                ref={selfieInputRef}
                multiple // Allow multiple files
                onChange={handleSelfieChange}
              />
            </div>
            <div className="col-md-6">
              <label className="col-form-label">
                Upload Visit Picture <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                type="file"
                accept="image/*"
                ref={fileInputRef}
                multiple // Allow multiple files
                onChange={handleFileChange}
              />
            </div>
            <div className="col-md-12">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Visit Remarks <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={LocalFormData.VisitRemark || ""}
                  onChange={(e) =>
                    setLocalFormData({
                      ...LocalFormData,
                      VisitRemark: e.target.value,
                    })
                  }
                  placeholder="Enter visit remarks here..."
                ></textarea>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};
